// ----------------------------------------------------------------------------
// Component: Blog Posts
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';

// Styles
import './_blog-posts.scss';